import { Box, Input, Typography } from "@mui/material";
import React from "react";
import { useTreeModifyContext } from "./TreeDataContext";
import { clamp } from "./MathHelpers";

interface RootDimsNodeProps {
  value: number[];
}

export function RootDimsNode(props: RootDimsNodeProps) {
  const { saveChangesAtPath } = useTreeModifyContext();
  if (!Array.isArray(props.value) || props.value.length !== 2) {
    return <Typography>Incorrect dims</Typography>;
  }

  return (
    <Box className="horizontal-flex">
      <Typography>Dimensions&nbsp;</Typography>
      <Typography>X:</Typography>
      <Input
        type="number"
        id="dims-x"
        defaultValue={props.value[0]}
        slotProps={{ input: { type: "number", min: 1, max: 1000 } }}
        onBlur={(event) => {
          let value = parseInt(event.target.value);
          if (value !== undefined) {
            value = clamp(value, 1, 1000);
            saveChangesAtPath(value, ["dims", "0"]);
            event.target.value = value.toString();
          }
        }}
      />
      <Typography>Y:</Typography>
      <Input
        type="number"
        id="dims-y"
        defaultValue={props.value[1]}
        slotProps={{ input: { type: "number", min: 1, max: 1000 } }}
        onBlur={(event) => {
          let value = parseInt(event.target.value);
          if (value !== undefined) {
            value = clamp(value, 1, 1000);
            saveChangesAtPath(value, ["dims", "1"]);
            event.target.value = value.toString();
          }
        }}
      />
    </Box>
  );
}
